// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"15":"249e1bc4","106":"afdab3aa","118":"789a9ca4","134":"991177e5","192":"2b66efc9"}[chunkId] + ".chunk.css";
};